import { httpCreate } from './http';

const http = httpCreate('/srv/rtc');

export const rtc = {
	openTranscribe(activityId) {
		return http.post(`/mpu/startRecord/${activityId}`);
	},
	getTranscribeRecord(activityId) {
		return http.get(`/getRecord/${activityId}`);
	},
	stopTranscribe(activityId, params) {
		return http.post(`/mpu/stopRecord/${activityId}?taskId=${params}`);
	},
};
